import { useState } from "react";
import { useFeatureTheme } from "../../context/FeatureThemeContext";
import { Modal } from "../common/Modal";
import { Button } from "../common/Button";

const SEEN_KEY = "beekeeper.onboarding_seen";

const BASIC_STEPS = [
  "Welcome to Bee Keeper! Your Dashboard shows total hives, what's due today, and any issues at a glance.",
  "Tap a hive to see its details, or use the big Action Buttons for one-click logging in the field.",
  "Add your first hive from the Hives page — free accounts include up to 5 hives.",
];

const ADVANCED_STEPS = [
  ...BASIC_STEPS,
  "With the Advanced theme, your Dashboard also shows Health Triage (worst hives first) and a Team Activity feed.",
  "Hive Detail now has tabs for Queen, Treatments, Feedings, Harvest, Equipment, and Bloom data.",
  "Check out Business → P&L Dashboard and Reports for financial and regulatory reporting.",
];

export function OnboardingTour() {
  const { theme, loading } = useFeatureTheme();
  const [step, setStep] = useState(0);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(SEEN_KEY) === "true");

  if (loading || dismissed) return null;

  const steps = theme === "Basic" ? BASIC_STEPS : ADVANCED_STEPS;

  function finish() {
    localStorage.setItem(SEEN_KEY, "true");
    setDismissed(true);
  }

  return (
    <Modal
      open
      onClose={finish}
      title={`Quick Tour (${step + 1}/${steps.length})`}
      footer={
        <>
          <Button variant="ghost" onClick={finish}>Skip</Button>
          {step < steps.length - 1 ? (
            <Button onClick={() => setStep((s) => s + 1)}>Next</Button>
          ) : (
            <Button onClick={finish}>Done</Button>
          )}
        </>
      }
    >
      <p>{steps[step]}</p>
    </Modal>
  );
}
